import { Injectable } from '@angular/core';
import { Form } from 'src/app/interfaces/form';
import { APIProviderService } from '../api/api.provider.service';
import { GemstoneSetting } from 'src/app/interfaces/gemstone-setting';

@Injectable({
  providedIn: 'root'
})
export class StoneSettingsProviderService extends APIProviderService<GemstoneSetting> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Gemstones/Settings`;
  }
}
